export const SERVICE_PROVIDERS = {
  dhl: "dhl",
  flash: "flash",
  jnt: "jnt",
  ninjavan: "ninjavan",
  citylink: "citylink",
  teleport: "teleport",
  poslaju: "poslaju",
  sfstandard: "sfstandard",
  sfexd: "sfexd",
  sfeconomy: "sfeconomy",
  fedex: "fedex",
  redly: "redly",
  best: "best",
  aramex: "aramex",
  lineclear: "lineclear",
  spx: "spx",
  kex: "kex",
  lex: "lex",
  bestcargo: "bestcargo",
};

export const INSTANT_SERVICE_PROVIDERS = {
  grab4hr: "grab4hr",
  grabBike: "grabBike",
  grabCar: "grabCar",
  pandagoBike: "pandagoBike",
  lalamoveMoto: "lalamoveMoto",
  lalamoveCar: "lalamoveCar",
  lalamoveCarD2D: "lalamoveCarD2D",
}

export const SERVICE_PROVIDER_DETAILS = [
  {
    key: "dhl",
    name: "DHL",
    color: "yellow",
    hasPickup: true,
  },
  {
    key: "flash",
    name: "Flash",
    color: "red",
    isClosed: true
  },
  {
    key: "jnt",
    name: "J&T",
    color: "geekblue",
  },
  {
    key: "ninjavan",
    name: "Ninjavan",
    color: "green",
  },
  {
    key: "citylink",
    name: "Citylink",
    color: "purple",
    isManualCancel: true,
  },
  {
    key: "teleport",
    name: "Teleport",
    color: "cyan",
  },
  {
    key: "poslaju",
    name: "Poslaju",
    color: "magenta",
    isManualCancel: true,
  },
  {
    key: "sfstandard",
    name: "SF Standard",
    color: "green",
  },
  {
    key: "sfeconomy",
    name: "SF Economy",
    color: "lime",
  },
  {
    key: "fedex",
    name: "Fedex",
    color: "grey",
    isPublic: false,
  },
  {
    key: "aramex",
    name: "Aramex",
    color: "orange",
    hasPickup: true,
    isManualCancel: true,
  },
  {
    key: "redly",
    name: "Redly",
    color: "pink",
    isManualCancel: true,
  },
  {
    key: "lineclear",
    name: "Lineclear",
    color: "teal",
  },
  {
    key: "best",
    name: "Best",
    color: "blue",
  },
  {
    key: "spx",
    name: "SPX",
    color: "volcano",
  },
  {
    key: "lex",
    name: "LEX",
    color: "purple",
  },
  {
    key: "kex",
    name: "KEX",
    color: "orange",
  },
  {
    key: "sfexd",
    name: "SF Exd",
    color: "orange",
  },
  {
    key: "bestcargo",
    name: "Best Cargo",
    color: "purple",
  },
  {
    key: "grab4hr",
    name: "GrabExpress 4-Hour",
    color: "blue",
  },
  {
    key: "grabBike",
    name: "GrabExpress Instant Bike",
    color: "blue",
  },
  {
    key: "grabCar",
    name: "GrabExpress Instant Car",
    color: "blue",
  },
  {
    key: "pandagoBike",
    name: "pandago Bike",
    color: "blue",
  },
  {
    key: "lalamoveMoto",
    name: "Lalamove Motor",
    color: "blue",
  },
  {
    key: "lalamoveCarD2D",
    name: "Lalamove Car (D2D)",
    color: "blue",
  },
  {
    key: "lalamoveCar",
    name: "Lalamove Car",
    color: "blue",
  },
];

export const COD_SERVICE_PROVIDERS = [
  SERVICE_PROVIDERS.dhl,
  SERVICE_PROVIDERS.ninjavan,
  SERVICE_PROVIDERS.jnt,
  SERVICE_PROVIDERS.poslaju,
  SERVICE_PROVIDERS.citylink,
  SERVICE_PROVIDERS.best,
  SERVICE_PROVIDERS.aramex,
  SERVICE_PROVIDERS.kex,
  SERVICE_PROVIDERS.spx,
];

export const WEBHOOKLESS_SERVICE_PROVIDERS = [
  SERVICE_PROVIDERS.poslaju,
  SERVICE_PROVIDERS.citylink,
  SERVICE_PROVIDERS.lineclear,
  SERVICE_PROVIDERS.aramex,
];
